module.exports = __webpack_public_path__ + "static/img/bg3.43c7aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg3.png
// module id = vegf
// module chunks = 78